// stackoverflow spesh - splits array into arrays of size chunkSize,
// i.e [1,2,3,4,5,6,7,8,9,10] with chunkSize 3 becomes
//    [[1,2,3],[4,5,6],[7,8,9],[10]]
export function chunk<T>(array: T[], chunkSize: number): T[][] {
  const R = [];
  for (let i = 0, len = array.length; i < len; i += chunkSize)
    R.push(array.slice(i, i + chunkSize));
  return R;
}
